"use strict";

import angular from "angular";

/**
 * @component NuSvgCheck
 * O <nu-svg-check> show an icon of checked or success
 * @this { controllerAs } - svgCheck
 */

import template from "./svg-check.component.html";
import "./svg-check.scss";

const name = "nuSvgCheck";
const def = {
    bindings: {},
    controllerAs: "svgCheck",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
